import { IonModal, IonContent, IonIcon } from '@ionic/react'
import React from 'react'
import { IBaseModalProps } from './base-modal-props.interface'
import { icon_close } from 'icons'
import './base-modal.scss'

const BaseModal: React.FC<IBaseModalProps> = ({ isOpen, setIsOpen, children, title, footer, dismiss, className }) => {
  function baseDismiss() {
    setIsOpen(false)
  }

  const finalDismiss = dismiss ?? baseDismiss

  return (
    <IonModal className={'edisu-base-modal ' + className} isOpen={isOpen} onIonModalDidDismiss={() => finalDismiss()}>
      <IonContent className="edisu-modal-content">
        <div className="modal-header">
          <IonIcon icon={icon_close} onClick={() => finalDismiss()} />
        </div>
        {children && (
          <div className="modal-content">
            {!!title && <p className="modal-text ion-text-capitalize">{title}</p>}
            <div className="injected-content">{children}</div>
          </div>
        )}
        {footer && <div className="modal-footer">{footer} </div>}
      </IonContent>
    </IonModal>
  )
}

export default BaseModal
